"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Is the mosquito treatment safe for my pets and children?",
  answer: "Yes, safety is our top priority. We use professional-grade products that are EPA-approved and applied by FDACS licensed technicians. Once the treatment has dried—typically within 30 minutes—it is perfectly safe for your family and pets to enjoy the yard."
}, {
  question: "How often do I need mosquito control services in Florida?",
  answer: "Given the humid climate in Punta Gorda and surrounding areas, we recommend a recurring barrier treatment every 21 to 30 days during peak mosquito season to maintain a consistent protective shield around your property."
}, {
  question: "What happens if it rains shortly after a treatment?",
  answer: "Our specialized formulas are designed to be weather-resistant once dry. However, if heavy tropical rains occur within a few hours of application and you notice a return of mosquito activity, we provide a satisfaction guarantee and will re-treat at no extra cost."
}, {
  question: "Do you treat standing water or just the foliage?",
  answer: "We perform a comprehensive inspection and treatment. This includes applying larvicides to non-potable standing water to prevent breeding and treating the underside of leaves where adult mosquitoes rest during the heat of the day."
}, {
  question: "Are your technicians licensed to work in Charlotte County?",
  answer: "Absolutely. Peace River Pest Control is a fully insured and FDACS Licensed Pest Control and Termite Operator. Our local technicians are specifically trained on the pest pressures unique to Port Charlotte, Cape Coral, and Punta Gorda."
}];
export default function FaqSection() {
  return <section data-section-id="249093" id="mosquito-faq" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="font-default mb-4 text-3xl font-bold tracking-tight sm:text-4xl uppercase">
            Mosquito Control FAQ
          </h2>
          <p className="font-default text-primary text-lg font-medium">
            Expert answers for homeowners in Punta Gorda and Southwest Florida.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full [&_[data-slot=accordion-trigger]>svg]:text-primary [&_[data-slot=accordion-trigger]>svg]:rotate-0 [&_[data-slot=accordion-trigger][data-state=open]>svg]:rotate-45 transition-transform">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-primary/20 py-2">
              <AccordionTrigger className="font-default text-primary hover:text-primary/80 text-left text-base font-bold transition-colors hover:no-underline sm:text-lg">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-serif text-primary text-xl leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}